import React from 'react';
import Datamaps from 'datamaps';

import countryNames from '../../../helpers/countryNames';
import { CURRENT_YEAR } from '../../../helpers/various-helpers';

import mapStyle, { countryStateColors } from './mapStyle';

export default class DataMap extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      formattedData: this.transformData(props.data)
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.data !== this.props.data) {
      this.setState({
        formattedData: this.transformData(nextProps.data)
      });
    }
  }

  transformData(data) {
    const transformedData = {};

    for (let key in countryNames) {
      let item = data[key],
        color;

      if (item) {
        if ((CURRENT_YEAR - item.reporting_year) < 2) {
          color = item.online
            ? countryStateColors.updated
            : countryStateColors.updatedOffline;
        } else {
          color = item.online
            ? countryStateColors.old
            : countryStateColors.oldOffline;
        }
      } else {
        color = countryStateColors.noReport;
      }

      transformedData[key] = {
        fillColor: color
      };
    }

    return transformedData;
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resize);
  }

  componentDidMount() {
    this.drawMap();
  }

  componentDidUpdate() {
    this.clear();

    if (this.state.formattedData) {
      this.drawMap();
    }
  }

  drawMap() {
    this.map = new Datamaps(
      {
        element: this.refs.unarmMapContainer,
        responsive: true,
        fills: {
          nonMemberstateFill: mapStyle.coloring.nonMemberstateFill,
          defaultFill: mapStyle.coloring.fillColor // Any hex, color name or rgb/rgba value
        },
        geographyConfig: {
          dataUrl: 'worldmap-customized.topo.json',
          highlightFillColor: mapStyle.highlighting.highlightFillColor,
          highlightBorderColor: mapStyle.highlighting.highlightBorderColor,
          highlightBorderWidth: 1,
          borderColor: mapStyle.coloring.borderColor,
          popupTemplate: function (geography, data) {
            const hoverContent = '<div class="hoverinfo"><strong>'
              + geography.properties.name + '</strong></div>';
            return geography.properties.memberstate ? hoverContent : null;
          }
        },
        data: this.state.formattedData,
        done: datamap => {
          datamap.svg
            .selectAll('.datamaps-subunit')
            .on('click', geography => {
              if (geography.properties.memberstate) {
                this.props.onSelect(geography.id);
              }
            });
        },
      }
    );
  }

  clear() {
    const container = this.refs.unarmMapContainer;

    if (!container) return null;

    for (const child of Array.from(container.childNodes)) {
      container.removeChild(child);
    }
  }

  resize() {
    if (this.map) {
      this.map.resize();
    }
  }

  render() {
    if (!this.state.formattedData) return null;
    return <div ref="unarmMapContainer" style={mapStyle.positioning}></div>;
  }
}



// WEBPACK FOOTER //
// ./src/components/Home/DataMap/DataMap.js